// extracted by mini-css-extract-plugin
module.exports = {"services":"sites-module--services--RT4nu","bodyHairText":"sites-module--bodyHairText--F6AVD"};